import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { resetState } from "../duck/actions";

export default function FailureDialog() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const button = {
    text: t("buttons.ok"),
    onClick: () => {
      dispatch(resetState());
    }
  };
  const text = t(`pairing.failureDialog.text`);
  const heading = t(`pairing.failureDialog.heading`);

  return (
    <Dialog
      isOpen={true}
      type="failure"
      buttons={[button]}
      heading={heading}
      text={text}
    />
  );
}
